export default "__VITE_ASSET__CT0U2D0R__"